<div *transloco="let t; read: 'breakdown-table'" class="breakdown-table__container">
  <table
    #table
    mat-table
    multiTemplateDataRows
    [dataSource]="breakdowns"
    class="breakdown-table__table"
  >
    <ng-container matColumnDef="percent">
      <th mat-header-cell *matHeaderCellDef>
        {{ t('percent') }}
      </th>

      <td mat-cell *matCellDef="let breakdown" [matTooltip]="breakdown.count">
        {{ breakdown.weight | percent }}
      </td>
    </ng-container>

    <ng-container matColumnDef="breakdown">
      <th mat-header-cell *matHeaderCellDef>
        {{ t('breakdown') }}
      </th>

      <td
        mat-cell
        *matCellDef="let breakdown"
        [matTooltip]="breakdown.name"
        appShowMatTooltipIfTruncated
      >
        {{ breakdown.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="current">
      <th mat-header-cell *matHeaderCellDef>
        {{ t('current') }}
      </th>

      <td mat-cell *matCellDef="let breakdown">
        {{ breakdown.value | number: numberPipeDigitInfo }}
      </td>
    </ng-container>

    <ng-container matColumnDef="simulated">
      <th mat-header-cell *matHeaderCellDef>
        {{ t('simulated') }}
      </th>

      <td mat-cell *matCellDef="let breakdown">
        @if (breakdown.simulated) {
          <div class="breakdown-table__simulated">
            <span> {{ breakdown.simulated | number: numberPipeDigitInfo }} </span>
            @if (canResetSimulation(breakdown)) {
              <xi-icon
                appClickStopPropagation
                class="pointer"
                icon="refresh"
                color="CX"
                (onClick)="onResetBreakdownSimulation(breakdown)"
              ></xi-icon>
            }
          </div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="focused">
      <th mat-header-cell *matHeaderCellDef></th>

      <td mat-cell *matCellDef="let breakdown">
        @if (shouldShowFocusedIcon(breakdown)) {
          <div class="breakdown-table__focused-icon-wrapper">
            <xi-icon icon="circle_check_filled" color="CX"></xi-icon>
          </div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>

      <td mat-cell *matCellDef="let breakdown">
        <div
          [matMenuTriggerFor]="breakdownMenuTrigger"
          [matMenuTriggerData]="{ $implicit: breakdown }"
          (click)="$event.stopPropagation()"
        >
          <xi-icon-button color="CX" icon="kabob"></xi-icon-button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="percent-top">
      <th mat-header-cell *matHeaderCellDef></th>
    </ng-container>

    <ng-container matColumnDef="breakdown-top">
      <th mat-header-cell *matHeaderCellDef></th>
    </ng-container>

    <ng-container matColumnDef="score">
      <th mat-header-cell *matHeaderCellDef [attr.colspan]="2">
        <div *transloco="let it; read: 'metric-settings-form'" class="breakdown-table__score">
          {{ t('score', { scoring: it(scoringKey) }) }}
        </div>
      </th>
    </ng-container>

    <ng-container matColumnDef="settings">
      <th mat-header-cell *matHeaderCellDef [attr.colspan]="2"></th>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="TOP_COLUMNS; sticky: true"></tr>

    <tr mat-header-row *matHeaderRowDef="DISPLAYED_COLUMNS; sticky: true"></tr>

    <tr
      mat-row
      *matRowDef="let breakdown; columns: DISPLAYED_COLUMNS"
      class="breakdown-table__main-row"
      [class.breakdown-table__selected-breakdown]="isSelectedBreakdown(breakdown)"
      [class.pointer]="!isSelectedBreakdown(breakdown)"
      [ngClass]="
        isSelectedBreakdown(breakdown)
          ? 'breakdown-table__main-row--expanded'
          : 'breakdown-table__main-row--collapsed'
      "
      (click)="onSelectBreakdown(breakdown)"
    ></tr>
  </table>

  <mat-menu #breakdownMenuTrigger>
    <ng-template matMenuContent let-breakdown>
      <button
        mat-menu-item
        [disabled]="allBreakdownName === breakdown.name"
        (click)="onHideBreakdown(breakdown)"
      >
        <xi-icon
          [color]="allBreakdownName === breakdown.name ? 'disabled' : 'orca'"
          icon="remove_circle"
        ></xi-icon>
        <div>
          {{ t('hide-item') }}
        </div>
      </button>
    </ng-template>
  </mat-menu>
</div>
